import React, { useState, forwardRef, useImperativeHandle } from 'react'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
const CompetitionDraw = forwardRef(({ defaultvar = '' }, ref) => {
  const currencies_tournament_draw = [
    {
      value: 'Простая',
      label: 'Простая',
      help: 'очередь -> сектор',
    },
    {
      value: 'Раздельная',
      label: 'Раздельная',
      help: 'очередь -> зона -> сектор',
    },
    {
      value: 'Готовыми комбинациями секторов',
      label: 'Готовыми комбинациями секторов',
      help: 'очередь -> комбинация -> зона',
    },
  ]
  const [value, setValue] = React.useState(defaultvar)
  const [error, setError] = useState('')
  const val = () => {
    return value.trim()
  }
  const validate = () => {
    if (value.trim() === '') {
      setError('Продолжительность турнира обязательно')
      return false
    }
    setError('')
    return true
  }
  useImperativeHandle(ref, () => ({
    validate,
    val,
  }))

  return (
    <TextField
      id="tournament_draw"
      select
      label="Жеребьевка"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      error={!!error}
      // helperText={error}
      variant="filled"
    >
      {currencies_tournament_draw.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span>{option.label}</span>
            <span style={{ fontSize: '0.8em', color: 'gray' }}>
              {option.help}
            </span>
          </div>
        </MenuItem>
      ))}
    </TextField>
  )
})

export default CompetitionDraw
